// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__BjaAr","label":"Category_label__15qCY","content":"Category_content__2AlcN","header":"Category_header__2Kgfh","location":"Category_location__QF3Vb"};